import { useState } from 'react'
import { InputAdornment, TextField } from '@mui/material'

const toNumber = (text: string) => {
  const n = Number(text)
  return text === '' || Number.isNaN(n) ? 0 : n
}

// Text input restricted to non-negative numbers with at most `decimals` decimals.
// It keeps the raw text locally so an empty field (not filled yet) and a typed
// "0" (filled) are distinguishable, while `value` stays a plain number.
export default function DecimalInput({
  label,
  value,
  onChange,
  unit,
  decimals = 2,
  size = 'medium',
  required = false,
}: {
  label: string
  value: number
  onChange: (value: number) => void
  unit: string
  decimals?: number
  size?: 'small' | 'medium'
  required?: boolean
}) {
  const [text, setText] = useState(value === 0 ? '' : String(value))

  // The value changed from outside (computed / loaded): resync the displayed text.
  if (toNumber(text) !== value) setText(value === 0 ? '' : String(value))

  const pattern = new RegExp(decimals > 0 ? `^\\d*([.,]\\d{0,${decimals}})?$` : '^\\d*$')

  return (
    <TextField
      size={size}
      label={label}
      value={text}
      required={required}
      onChange={(e) => {
        const next = e.target.value
        if (!pattern.test(next)) return
        const normalized = next.replace(',', '.')
        setText(normalized)
        onChange(toNumber(normalized))
      }}
      slotProps={{
        htmlInput: { inputMode: decimals > 0 ? 'decimal' : 'numeric' },
        input: { endAdornment: <InputAdornment position="end">{unit}</InputAdornment> },
      }}
    />
  )
}
